import { OverlayService } from './../../services/overlay.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToolsService } from './../../services/tools.service';
import { GalleryService } from './../gallery.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from './../../store';
import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-gallery-manage',
    templateUrl: './gallery-manage.component.html',
    styleUrls: ['./gallery-manage.component.scss']
})
export class GalleryManageComponent implements OnInit {
    env = environment;
    form: FormGroup;

    itemId = '';
    item;
    isNew = false;
    uploadConfig: any;
    toSave = [];
    itemToDelete;
    imageToEdit;
    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    constructor(
        private store: Store,
        private router: Router,
        private route: ActivatedRoute,
        private toastrService: ToastrService,
        private galleryService: GalleryService,
        private toolsService: ToolsService,
        private fb: FormBuilder,
        private overlayService: OverlayService,
    ) {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            maxWidth: [1440, [Validators.required]],
            maxHeight: [900, [Validators.required]],
            status: [1, [Validators.required]],
            slidesPerView: [4, [Validators.required]],
            showDots: [1, [Validators.required]],
            showNav: [1, [Validators.required]],
            spacing: [0, [Validators.required]],
            border: [0, [Validators.required]],
            loopImages: [1, [Validators.required]],
            marginV: [0, [Validators.required]],
            marginH: ['', [Validators.required]],
        });
    }

    ngOnInit() {
        this.itemId = this.route.snapshot.params.id;

        if (this.itemId !== 'new') {
            this.get();
            this.isNew = false;
        } else {
            this.isNew = true;
            this.item = {
                id: this.toolsService.newUUID(),
                name: '',
                maxWidth: 1440,
                maxHeight: 900,
                status: 1,
                slidesPerView: 4,
                showDots: true,
                showNav: true,
                spacing: 15,
                border: 0,
                arrowColour: '',
                loopImages: true,
                marginV: 0,
                marginH: 0,
                images: [],
            };
            this.initUpload();
        }

    }

    toggleValue(v) {
        if (!this.form.value[v]) {
            this.form.get(v).patchValue(1)
        } else {
            this.form.get(v).patchValue(0)
        }
    }


    get() {
        this.galleryService.get(this.itemId).subscribe(data => {
            this.item = data.data;
            this.form.patchValue({
                name: data.data.name,
                maxWidth: data.data.maxWidth,
                maxHeight: data.data.maxHeight,
                status: data.data.status,
                slidesPerView: data.data.slidesPerView,
                showDots: data.data.showDots,
                showNav: data.data.showNav,
                spacing: data.data.spacing,
                border: data.data.border,
                arrowColour: data.data.arrowColour,
                loopImages: data.data.loopImages,
                marginV: data.data.marginV,
                marginH: data.data.marginH,
            })
            this.initUpload();

        });
    }

    getGalleryImages() {
        this.galleryService.getGalleryImages(this.itemId).subscribe(data => {
            this.item.images = data.data;
        });
    }


    onSubmit() {
        this.item.name = this.form.value.name;
        this.item.maxWidth = this.form.value.maxWidth;
        this.item.maxHeight = this.form.value.maxHeight;
        this.item.status = this.form.value.status;
        this.item.slidesPerView = this.form.value.slidesPerView;
        this.item.showDots = this.form.value.showDots;
        this.item.showNav = this.form.value.showNav;
        this.item.spacing = this.form.value.spacing;
        this.item.border = this.form.value.border;
        this.item.arrowColour = this.form.value.arrowColour;
        this.item.loopImages = this.form.value.loopImages;
        this.item.marginV = this.form.value.marginV;
        this.item.marginH = this.form.value.marginH;

        if (this.isNew) {
            this.galleryService.create(this.item).subscribe(data => {
                this.isNew = false;
                this.toastrService.success('Gallery created successfully');
                this.router.navigate(['/cms', 'galleries']);
            });
        } else {
            this.galleryService.update(this.item).subscribe(data => {
                this.toastrService.success('Gallery updated successfully');
                // this.router.navigate(['/cms','galleries']);
            });
        }
    }

    editImageMeta(image) {
        this.imageToEdit = image;
    }
    imageMetaUpdated(e) {
        this.imageToEdit = undefined;
        if (e.action) {
            if (e.repeatForAll) {
                this.getGalleryImages();
            }
            this.toastrService.success('Image details updated');
        }
    }
    deleteConfirm(item) {
        this.itemToDelete = item;
        this.confirmationData.title = `Please confirm you would like to delete this image`;
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
    }

    delete(e) {
        this.confirmationData.open = false;
        if (e.action) {
            this.galleryService.deleteImage(this.itemToDelete.id).subscribe(data => {
                this.item.images.forEach((i, idx) => {
                    if (i.id === this.itemToDelete.id) {
                        this.item.images.splice(idx, 1);
                        this.toastrService.success('Gallery image deleted');
                    }
                })
                // this.get();
            });
        }
    }


    drop(e) {
        // moveItemInArray(this.images, event.previousIndex, event.currentIndex);
        this.toSave = e;
        this.galleryService.updateSortOrder(this.toSave).subscribe();
        this.toastrService.success('Sort order saved');
    }

    initUpload() {
        this.uploadConfig = {
            url: this.env.imageUploadPath + 'cms/gallery/images/upload',
            acceptedFiles: 'image/*',
            resizeWidth: this.form.value.maxWidth,
            parallelUploads: 1,
            maxFiles: 8,
            maxFilesize: 5120,
            params: {
                gallery: this.item.id
            },
            // The API's upload routes now require the admin session: send the cookie and
            // the app-name the API uses to pick auth.app.admin (Dropzone bypasses the interceptor).
            withCredentials: true,
            headers: {
                'api-key': '6bf9284a-ebf9-4afa-a185-4d2b9bb29e85',
                'app-name': 'admin'
            },
        };
    }
    onUploadError(e) {
        this.initUpload();
    }
    onUploadSuccess(e) {
        this.item.images.push(e[1].data);
    }
    uploadprogress(e) {
    }
    queueComplete(e) {
        this.initUpload();
    }

}
